// extracted by mini-css-extract-plugin
export var card = "_1-5";
export var counter = "_1-4";
export var leftInner = "_1-0";
export var spacer = "_1-1";
export var subtitle = "_1-3";
export var title = "_1-2";